import { render, staticRenderFns } from "./koditem4c.vue?vue&type=template&id=071b8eac&scoped=true"
import script from "./koditem4c.vue?vue&type=script&lang=js"
export * from "./koditem4c.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b8eac",
  null
  
)

export default component.exports